export default __webpack_public_path__ + "static/media/metal.757cfd3a.jpg";